// extracted by mini-css-extract-plugin
var _1 = "CarouselThumbnail-module__isDragging--pBEfA";
var _2 = "CarouselThumbnail-module__thumbnail--Ckgry";
export { _1 as "isDragging", _2 as "thumbnail" }
